import { makeStyles } from "@material-ui/core/styles"

export default makeStyles((theme) => ({
  main: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(3)
  },
  button: {
    alignSelf: "flex-end"
  },
  withMargin: {
    marginTop: theme.spacing(4)
  }
}))
